/**
 * Unlayer editor theme configurations matching Ruvixx brand guidelines.
 *
 * Extends Unlayer's built-in modern_light / modern_dark themes with our
 * brand accent color (Ruvixx orange). We intentionally leave the primary
 * color scale untouched so the built-in themes handle surface/text contrast
 * correctly.
 */

const lightTheme = {
  name: "ruvixx_light",
  extends: "modern_light",
  isDark: false,
  mapping: {
    colors: {
      accent_01: "#ff6b35",
      accent_02: "#f34a02",
      accent_03: "#ff6b35",
      accent_04: "#fff3ee",
      accent_05: "#ff6b35",
    },
  },
};

const darkTheme = {
  name: "ruvixx_dark",
  extends: "modern_dark",
  isDark: true,
  mapping: {
    colors: {
      accent_01: "#ff6b35",
      accent_02: "#f34a02",
      accent_03: "#ff6b35",
      accent_04: "#3d2010",
      accent_05: "#ff6b35",
    },
  },
};

/**
 * Returns the Unlayer theme config for the current app theme.
 * Reads from the data-theme attribute on <html>.
 */
export function getUnlayerTheme() {
  const isDark = document.documentElement.dataset.theme === "dark";
  return isDark ? darkTheme : lightTheme;
}

export { lightTheme, darkTheme };
